import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wl-web-content-edit',
  templateUrl: './web-content-edit.component.html',
  styleUrls: ['./web-content-edit.component.less'],
    standalone: false
})
export class WebContentEditComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
